import * as React from 'react';
import {
  IconMetroEkb16,
  IconMetroKzn16,
  IconMetroMsk16,
  IconMetroNN16,
  IconMetroNovosib16,
  IconMetroSam16,
  IconMetroSpb16,
} from '@cian/ui-kit';
import { EUndergroundType } from '../../../../types/promosPage';

export const useUndergroundIcon = (undergroundType: EUndergroundType) => {
  return React.useMemo(() => {
    switch (undergroundType) {
      case EUndergroundType.Spb:
        return <IconMetroSpb16 color="current_color" />;
      case EUndergroundType.Ekb:
        return <IconMetroEkb16 color="current_color" />;
      case EUndergroundType.Kzn:
        return <IconMetroKzn16 color="current_color" />;
      case EUndergroundType.Nsk:
        return <IconMetroNovosib16 color="current_color" />;
      case EUndergroundType.Smr:
        return <IconMetroSam16 color="current_color" />;
      case EUndergroundType.Nn:
        return <IconMetroNN16 color="current_color" />;
      default:
        return <IconMetroMsk16 color="current_color" />;
    }
  }, [undergroundType]);
};
